export default __webpack_public_path__ + "static/media/rightArrowCircle.ab2453a0.svg";